import cloneDeep from 'lodash/cloneDeep'

import campaignApi from '@/api/campaign'

const state = {
  tags: []
}

// getters
const getters = {
  enabledMetrics: function(state, getters, rootState, rootGetters) {
    console.log(rootGetters)
    const metrics = []
    const c = rootGetters['user/currentCampaign']
    if (!c) {
      return metrics
    }
    if (c.nps_enabled) {
      metrics.push('NPS')
    }
    if (c.csat_enabled) {
      metrics.push('CSAT')
    }
    if (c.ces_enabled) {
      metrics.push('CES')
    }
    return metrics
  },
  tags: function(state, getters, rootState, rootGetters) {
    return state.tags
  }
}

// mutations
const mutations = {
  setTags(state, tags) {
    state.tags = tags
  }
}

// actions
const actions = {
  updateMetricStatus({ commit, state, rootState, context }, data) {
    return new Promise(function(resolve, reject) {
      console.log(data)
      campaignApi
        .updateMetricStatus(data.campaignId, data)
        .then(function(res) {
          const user = cloneDeep(rootState.user.user)
          user.projects[0].campaigns.splice(0, 1, res.data.results)
          commit('user/setUser', user, { root: true })
          resolve(res.data.results)
        })
        .catch(function(err) {
          console.log(JSON.stringify(err))
          reject(err.response.data.errors)
        })
    })
  },
  updateCampaignSettings({ commit, state, rootState, context }, data) {
    return new Promise(function(resolve, reject) {
      console.log(data)
      campaignApi
        .updateCampaignSettings(data.campaignId, data)
        .then(function(res) {
          const user = cloneDeep(rootState.user.user)
          user.projects[0].campaigns.splice(0, 1, res.data.results)
          commit('user/setUser', user, { root: true })
          resolve(res.data.results)
        })
        .catch(function(err) {
          console.log(JSON.stringify(err))
          reject(err.response.data.errors)
        })
    })
  },
  updateAppearance({ commit, state, rootState, context }, data) {
    return new Promise(function(resolve, reject) {
      console.log(data)
      campaignApi
        .updateAppearance(data.campaignId, data.form)
        .then(function(res) {
          const user = cloneDeep(rootState.user.user)
          user.projects[0].campaigns.splice(0, 1, res.data.results)
          commit('user/setUser', user, { root: true })
          resolve(res.data.results)
        })
        .catch(function(err) {
          console.log(JSON.stringify(err))
          reject(err.response.data.errors)
        })
    })
  },
  getQuestions({ commit, state, rootState, context }, data) {
    return new Promise(function(resolve, reject) {
      console.log(data)
      campaignApi
        .getQuestions(data.campaignId, data.type)
        .then(function(res) {
          resolve(res.data.results)
        })
        .catch(function(err) {
          console.log(JSON.stringify(err))
          reject(err.response.data.errors)
        })
    })
  },
  getTags({ commit, state, rootState, context }, data) {
    return new Promise(function(resolve, reject) {
      console.log(data)
      if (state.tags.length === 0)
        campaignApi
          .getTags(data.campaignId, data.type)
          .then(function(res) {
            commit('campaign/setTags', res.data.results, { root: true })
            resolve(res.data.results)
          })
          .catch(function(err) {
            console.log(JSON.stringify(err))
            reject(err.response.data.errors)
          })
      else {
        resolve(state.tags)
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
